import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpFormsDataService } from '@discoverer/dynamic-forms/dyn-forms/services';
import { DialogsManagerService } from '@discoverer/dynamic-reports/dialogs';
import { Subject } from 'rxjs';
import { CommonRelatedEntityController } from '../../../common/common-related-entity.controller';
import { AccessDialogComponent } from './access-dialog/access-dialog';
import { orderBy } from '@progress/kendo-data-query';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmployeeAccess } from '@app/ATS/models/employee-access';
import { DataFormattingService } from '@discoverer/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'accessible-apps',
    templateUrl: './accessible-apps.component.html',
    styleUrls: ['./accessible-apps.component.scss'],
    providers: [
        HttpFormsDataService
    ]
})

export class AccessibleAppsComponent extends CommonRelatedEntityController<EmployeeAccess>  {
    @Output() dataChanged = new EventEmitter(false);
    @Input() resetReportSubject: Subject<boolean> = new Subject<boolean>();
    @Input() currentlyAssigned: boolean;
    @Input() set employee(value) {
        this._employee = value;
        this.refreshFilters(value);
    }

    public formattingService = new DataFormattingService();
    public defaultRequestId = 'afbd0032-9993-44a0-a2d0-e1111c083333';
    private _employee;

    constructor(
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private httpDatService: HttpFormsDataService,
        public dialogService: DialogsManagerService
    ) {
        super(EmployeeAccess, dialogService, dialog, 'ats', 'access', AccessDialogComponent, [ 'Subtype', 'GivenBy',
            'StartDate', 'EndDate'], 'Type', 'asc');
        this.httpDatService.formServicePath = `/api/es/form/ats/access`;
    }

    public async editAccess(dataItem) {
        dataItem.preFilled = true;
        await this.editDataItem(dataItem);
        this.dataChanged.emit(true);
    }

    public get filteredData() {
        if (this.context) {
            return {
                data: orderBy(this.context.data.filter(d => d.IsCurrentlyAssigned === this.currentlyAssigned), this.sort),
                total: this.context.data.length
            };
        }
        return this.gridView;
    }


    private refreshFilters(value: any) {
        this.filters = [{ type: 'facet', filters: [], fields: ['EmployeeId'], expression: [value.Id] }];
    }
}
